<template>
  <b-modal
    id="info-modal"
    size="lg"
    ref="info_modal"
    title="Edytuj dane podstawowe budowy"
    @hidden="onClose"
    @show="onShow"
  >
    <div
      class="project-paretname"
      v-if="info.parent_name"
      :style="setProjectsCollors(info.color)"
    >
      {{ info.parent_name }}
    </div>
    <ValidationObserver
      ref="infoFormValidation"
      tag="form"
      @submit.prevent="onSubmit"
      id="constructionInfo"
    >
      <ConstructionFormInfo :form="this.form" :isMainProject="isMainProject" />
    </ValidationObserver>

    <template v-slot:modal-footer="{ cancel }">
      <b-button
        size="md"
        variant="primary"
        type="submit"
        form="constructionInfo"
        >Zapisz</b-button
      >
      <b-button size="md" variant="outline-danger" @click="cancel()"
        >Anuluj</b-button
      >
    </template>
  </b-modal>
</template>


<script>
import { mapActions } from "vuex";
import { setProjectsCollors } from "@/services/helpers";
import ConstructionFormInfo from "@/components/construction/ConstructionFormInfo";
import dayjs from "dayjs";

const FORMKEYS = [
  "id",
  "parent_id",
  "color",
  "name",
  "parent_name",
  "user_id",
  "company_id",
  "customer_id",
  "address",
  "pur",
  "planned_start_date",
  // "planned_end_date",
];

export default {
  name: "ConstructionModalFormInfo",
  components: { ConstructionFormInfo },
  props: {
    info: { type: Object },
    company: { type: Object },
  },
  data() {
    return {
      form: {},
      isMainProject: false,
    };
  },
  methods: {
    ...mapActions("construction", ["update"]),
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onShow() {
      this.$_.each(FORMKEYS, (key) => {
        this.form[key] = this.info[key];
      });
      this.form['company_id'] = this.company.id;
      this.form.planned_start_date = new Date(this.form.planned_start_date);
      // this.form.planned_end_date = new Date(this.form.planned_end_date);
      this.isMainProject = this.info.color !== null && this.info.parent_id === null;
    },
    onClose() {
      this.form = {};
    },
    onSubmit() {
      this.$refs.infoFormValidation.validate().then((success) => {
        this.form.planned_start_date = dayjs(
          this.form.planned_start_date
        ).format("YYYY-MM-DD");

        // this.form.planned_end_date = dayjs(
        //   this.form.planned_end_date
        // ).format("YYYY-MM-DD");

        if (!success) {
          return;
        }
        this.$Progress.start();
        this.update(this.form)
          .then(() => {
            this.$nextTick(() => {
              this.$bvModal.hide("info-modal");
            });
          })
          .catch((error) => {
            this.$refs.infoFormValidation.setErrors(error.response.data.fields);
          });
      });
    },
    setProjectsCollors,
  },
};
</script>
